import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { keyBy } from 'lodash';

import { isPresent } from 'helpers/string_helpers';
import Contacts from './contacts';
import configureStore from './store/configure';

import './styles.scss';

export class ContactIndex extends React.Component {
  static propTypes = {
    aggregateView: PropTypes.bool.isRequired,
    availableDatabases: PropTypes.array.isRequired,
    callLists: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired
    })),
    canAccessCrm: PropTypes.bool.isRequired,
    canDelete: PropTypes.bool.isRequired,
    canExport: PropTypes.bool.isRequired,
    canFindDuplicates: PropTypes.bool.isRequired,
    canManageTags: PropTypes.bool.isRequired,
    canViewProjects: PropTypes.bool.isRequired,
    contactPreviewProps: PropTypes.object.isRequired,
    contactRoles: PropTypes.array.isRequired,
    contactRolesMappings: PropTypes.object.isRequired,
    crmEmail: PropTypes.string,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    initialCompanyPage: PropTypes.string,
    initialPersonPage: PropTypes.string,
    initialPersonSort: PropTypes.string,
    initialTab: PropTypes.oneOf(['companies', 'people']),
    leadStatuses: PropTypes.array.isRequired,
    paths: PropTypes.object.isRequired,
    referralSources: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })),
    relatedContacts: PropTypes.object,
    svnMember: PropTypes.bool.isRequired,
    tags: PropTypes.array.isRequired
  };

  static defaultProps = {
    initialTab: 'people'
  };

  store = configureStore({
    callLists: {
      callLists: keyBy(this.props.callLists || [], list => list.id)
    },
    companies: {
      activeActivity: 1,
      activityNotes: '',
      activitySaved: false,
      deletingGroups: null,
      startBulkTagging: false,
      bulkTags: [],
      editingGroups: null,
      emailGroup: null,
      groups: [],
      tasks: [],
      databaseMembers: this.props.databaseMembers
    },
    duplicates: {
      companies: [],
      isLoading: true,
      meta: {
        companies: {
          currentPage: 1,
          pageSize: 25,
          totalCount: 0
        },
        people: {
          currentPage: 1,
          pageSize: 25,
          totalCount: 0
        }
      },
      people: [],
      viewActive: false
    },
    mappings: {
      contactRoles: this.props.contactRolesMappings
    },
    paths: this.props.paths,
    people: {
      activeActivity: 1,
      activitySaved: false,
      addLeadsToProjects: false,
      bulkTagging: false,
      bulkTags: [],
      bulkTasks: false,
      deletingGroups: null,
      editingGroups: null,
      emailGroup: null,
      groups: [],
      notes: '',
      startAddLeadsToProjects: false,
      startBulkDelete: false,
      startBulkTagging: false,
      startBulkTasks: false,
      tasks: [],
      databaseMembers: this.props.databaseMembers
    },
    query: {
      backToLink: '',
      companyGroupIds: [],
      companyPage: isPresent(this.props.initialCompanyPage) ? this.props.initialCompanyPage : 1,
      companySort: null, // Default changes depending on search text
      excludeTags: false,
      peopleGroupIds: [],
      personPage: isPresent(this.props.initialPersonPage) ? this.props.initialPersonPage : 1,
      personSort: this.props.initialPersonSort,
      propertyIds: [],
      roles: [],
      searchText: '',
      tags: [],
      tagIds: []
    },
    search: {
      companies: [],
      isFetching: true,
      meta: {
        companies: {
          allIds: [],
          currentPage: 0,
          pageSize: 25,
          totalCount: 0,
          totalUngroupedCount: 0,
          totalPages: 0,
          databaseCount: 0
        },
        people: {
          allIds: [],
          currentPage: 0,
          pageSize: 25,
          totalCount: 0,
          totalUngroupedCount: 0,
          totalPages: 0,
          databaseCount: 0
        }
      },
      people: [],
      relatedContacts: this.props.relatedContacts
    },
    session: {
      currentColumns: []
    },
    selectList: {
      selectedCompanyIds: [],
      selectedPersonIds: []
    },
    static: {
      aggregateView: this.props.aggregateView,
      availableDatabases: this.props.availableDatabases,
      contactRoles: this.props.contactRoles,
      crmEmail: this.props.crmEmail,
      currentUser: this.props.currentUser,
      leadStatuses: this.props.leadStatuses,
      referralSources: this.props.referralSources,
      tags: this.props.tags
    },
    ui: {
      alertMessage: '',
      canAccessCrm: this.props.canAccessCrm,
      canDelete: this.props.canDelete,
      canExport: this.props.canExport,
      canFindDuplicates: this.props.canFindDuplicates,
      canManageTags: this.props.canManageTags,
      canViewProjects: this.props.canViewProjects,
      contactPreviewProps: this.props.contactPreviewProps,
      currentTab: this.props.initialTab,
      error: false,
      mobileFiltersVisible: false,
      previewCompanyId: null,
      previewOverlayCallId: this.props.contactPreviewProps.callId,
      previewOverlayCallListId: this.props.contactPreviewProps.callListId,
      previewOverlayRecordId: this.props.contactPreviewProps.contactId,
      previewOverlayRecordType: this.props.contactPreviewProps.contactType,
      previewOverlayTaskId: this.props.contactPreviewProps.taskId,
      previewPersonId: null,
      showColumnFilters: false,
      svnMember: this.props.svnMember
    }
  });

  render() {
    return (
      <Provider store={this.store}>
        <Contacts />
      </Provider>
    );
  }
}

export default ContactIndex;
